/* ============================================================
   MAISON CANDELIA — gift-filter.js
   Filtrage hub cadeaux par budget ET occasion
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  const chips   = document.querySelectorAll('.gift-filter-chip');
  const items   = document.querySelectorAll('.gift-item');
  const empty   = document.getElementById('gift-empty');
  const counter = document.querySelector('.gift-count');

  // État courant des filtres
  const active = { budget: 'all', occasion: 'all' };

  function applyFilters() {
    let visible = 0;

    items.forEach(item => {
      const price    = parseFloat(item.dataset.price) || 0;
      const occasions = (item.dataset.occasions || '').split(/[\s,]+/);

      // Test budget
      let budgetOk = true;
      if (active.budget === '20')   budgetOk = price < 20;
      if (active.budget === '40')   budgetOk = price >= 20 && price <= 40;
      if (active.budget === 'plus') budgetOk = price > 40;

      // Test occasion
      let occasionOk = true;
      if (active.occasion !== 'all') {
        occasionOk = occasions.includes(active.occasion);
      }

      const show = budgetOk && occasionOk;
      item.style.display = show ? '' : 'none';
      if (show) visible++;
    });

    // Message vide
    if (empty) empty.style.display = visible === 0 ? 'block' : 'none';

    // Compteur
    if (counter) {
      counter.textContent = visible > 0
        ? `${visible} idée${visible > 1 ? 's' : ''} cadeau trouvée${visible > 1 ? 's' : ''}`
        : '';
    }
  }

  chips.forEach(chip => {
    chip.addEventListener('click', () => {
      const group = chip.dataset.group;
      const value = chip.dataset.value;

      // Mettre à jour l'état actif du groupe
      active[group] = value;

      // Mettre à jour les classes actives du groupe
      document.querySelectorAll(`.gift-filter-chip[data-group="${group}"]`)
        .forEach(c => c.classList.remove('active'));
      chip.classList.add('active');

      applyFilters();
    });
  });

  // Init
  applyFilters();
});
